<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <componentheader :title="title" />

        <div class="row">
          <div class="col-xl-3 col-md-4">
            <settingsidebar />
          </div>

          <div class="col-xl-9 col-md-8">
            <div class="card">
              <div class="card-header">
                <h5 class="card-title">General</h5>
              </div>
              <div class="card-body">
                <!-- Form -->
                <form @submit.prevent="updateSettings">
                  <div class="row form-group">
                    <label
                      for="name"
                      class="col-sm-3 col-form-label input-label"
                      >Business logo</label
                    >
                    <div class="col-9">
                      <div class="d-flex align-items-center">
                        <div v-if="imageUrl != null" class="uploaded">
                          <i
                            @click="deleteLogo"
                            class="feather feather-x-circle text-danger close-icon"
                            style="font-size: 20px; background-color: white"
                          ></i>
                          <img
                            v-if="imageUrl"
                            id="avatarImg"
                            class="upload-img"
                            :src="imageUrl"
                            alt="Business logo"
                          />
                        </div>
                        <div v-else class="col-sm-9 col-md-5 col-lg-5">
                          <div class="upload-div">
                            <div
                              class="d-flex flex-column align-center justify-center"
                            >
                              <div>
                                <i class="feather feather-upload-cloud"></i>
                              </div>
                              <p style="font-size: 12px">
                                Click here to upload image
                              </p>
                            </div>
                            <input
                              @change="onChangeImage"
                              type="file"
                              id="edit_img"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label
                      for="currencyLabel"
                      class="col-sm-3 col-form-label input-label"
                      >Invoice prefix</label
                    >
                    <div class="col-sm-9">
                      <input
                        v-model="form.invoice_prefix"
                        placeholder="INV"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="row form-group">
                    <label
                      for="currencyLabel"
                      class="col-sm-3 col-form-label input-label"
                      >Estimate prefix</label
                    >
                    <div class="col-sm-9">
                      <input
                        v-model="form.estimate_prefix"
                        placeholder="EST"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="row form-group">
                    <label
                      for="currencyLabel"
                      class="col-sm-3 col-form-label input-label"
                      >Service category</label
                    >
                    <div class="col-sm-9">
                      <select
                        class="form-select"
                        v-model="form.service_category"
                        required
                      >
                        <option disabled :value="null" selected>
                          Select an option
                        </option>
                        <option
                          v-for="(category, index) in categories"
                          :key="index"
                          :value="category"
                        >
                          {{ category }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label
                      for="currencyLabel"
                      class="col-sm-3 col-form-label input-label"
                      >Signature
                      <span
                        class="badge ms-2 fw-light bg-info text-center text-white text-capitalize"
                        >Premium</span
                      ></label
                    >
                    <div class="col-9">
                      <div class="d-flex align-items-center">
                        <div v-if="signatureUrl != null" class="uploaded">
                          <i
                            @click="deleteSignature"
                            class="feather feather-x-circle text-danger close-icon"
                            style="font-size: 20px; background-color: white"
                          ></i>
                          <img
                            v-if="signatureUrl"
                            id="avatarImg"
                            class="upload-img"
                            :src="signatureUrl"
                            alt="Business logo"
                          />
                        </div>

                        <div v-else class="col-sm-9 col-md-5 col-lg-5">
                          <div class="upload-div">
                            <div
                              class="d-flex flex-column align-center justify-center"
                            >
                              <div>
                                <i class="feather feather-upload-cloud"></i>
                              </div>
                              <p style="font-size: 12px">
                                Click here to upload signature
                              </p>
                            </div>
                            <input
                              @change="onChangeFile"
                              type="file"
                              :disabled="is_eligible"
                              id="edit_img"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label
                      for="currencyLabel"
                      class="col-sm-3 col-form-label input-label"
                      >Signatory name
                      <span
                        class="badge ms-2 fw-light bg-info text-center text-white text-capitalize"
                        >Premium</span
                      ></label
                    >
                    <div class="col-sm-9">
                      <input
                        v-model="form.signatory_name"
                        :disabled="is_eligible"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="row form-group">
                    <label
                      for="currencyLabel"
                      class="col-sm-3 col-form-label input-label"
                      >Preferred due date</label
                    >
                    <div class="col-sm-9">
                      <select
                        class="form-select"
                        v-model="form.preferred_due_date"
                        required
                      >
                        <option disabled :value="null" selected>
                          Select an option
                        </option>
                        <option
                          v-for="(day, index) in days"
                          :key="index"
                          :value="day.value"
                        >
                          {{ day.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label
                      for="currencyLabel"
                      class="col-sm-3 col-form-label input-label"
                    ></label>
                    <div class="col-sm-9">
                      <label class="custom_check me-3">
                        <input
                          type="checkbox"
                          true-value="1"
                          false-value="0"
                          v-model="form.auto_payment_reminder"
                          name="tax_enabled"
                        />
                        <span class="checkmark"></span> Auto payment reminder
                      </label>
                      <label class="custom_check me-3">
                        <input
                          type="checkbox"
                          true-value="1"
                          false-value="0"
                          v-model="form.payment_history_on_invoice_page"
                          name="tax_enabled"
                        />
                        <span class="checkmark"></span> Show payment history
                      </label>
                    </div>
                  </div>

                  <div class="text-end">
                    <button
                      :disabled="isLoading"
                      type="submit"
                      class="btn btn-primary add-tax-save-btn"
                    >
                      <span
                        v-if="isLoading"
                        class="spinner-border spinner-border-sm me-1"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span v-if="!isLoading">Save Changes</span>
                      <span v-if="isLoading">Saving...</span>
                    </button>
                  </div>
                </form>
                <!-- /Form -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  <!-- /Main Wrapper -->
</template>
<script setup>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();
const title = "Settings";
const isLoading = ref(false);
const categories = [
  "Advertising Industry",
  "Aerospace",
  "Agriculture and Farming",
  "Antiques and Collectibles",
  "Art",
  "Automotive Industry",
  "Banking & Financial Services",
  "Biotechnology",
  "Building Materials and Supplies",
  "Business Services",
  "Chemical Industry",
  "Cleaning Products and Services",
  "Cloud Computing",
  "Computer Hardware",
  "Construction Industry",
  "Consulting",
  "Consumer Electronics",
  "Consumer Goods",
  "Consumer Healthcare",
  "Crafts",
  "Culture Industry",
  "Data Storage and Management",
  "Defense Industry",
  "Design Industry",
  "Ecommerce",
  "Education and Training",
  "Energy",
  "Entertainment Industry",
  "Environmental Services",
  "Events Industry",
  "Fabrics and Textiles",
  "Fashion Industry",
  "Food & Beverage",
  "Healthcare Industry",
  "Heavy Industry",
  "Hospitality",
  "Information Technology",
  "Insurance",
  "Jewelry",
  "Leisure and Recreation",
  "Logistics and Supply Chain",
  "Luxury Goods",
  "Machinery and Heavy Equipment",
  "Manufacturing",
  "Media",
  "Medical Devices and Supplies",
  "Mining",
  "Music Industry",
  "Personal Services",
  "Pet Care and Supplies",
  "Pharmaceutical Industry",
  "Photography",
  "Printing",
  "Professional Services",
  "Publishing",
  "Real Estate",
  "Restaurants and Food Services",
  "Retail",
  "Robotics",
  "Security",
  "Social Media Industry",
  "Software",
  "Space",
  "Sports and Fitness",
  "Technology",
  "Telecom Industry",
  "Tools and Hardware",
  "Toys and Games",
  "Traditional Products",
  "Transportation",
  "Travel & Tourism",
  "Utilities",
  "Video Game Industry",
  "Waste Management"
];

const days = [
  { name: "3 days", value: 3 },
  { name: "7 days", value: 7 },
  { name: "14 days", value: 14 },
  { name: "30 days", value: 30 },
];

const form = ref({
  auto_payment_reminder: "0",
  invoice_prefix: "INV",
  estimate_prefix: "EST",
  service_category: null,
  preferred_due_date: null,
  signatory_name: "",
  signature: null,
  business_logo: null,
  payment_history_on_invoice_page: "0",
});

const signatureUrl = ref(null);

const onChangeFile = (event) => {
  signatureUrl.value = URL.createObjectURL(event.target.files[0]);
  form.value.signature = event.target.files[0];
};

const deleteSignature = () => {
  signatureUrl.value = null;
  form.value.signature = ''

};

const imageUrl = ref(null);

const onChangeImage = (event) => {
  imageUrl.value = URL.createObjectURL(event.target.files[0]);
  form.value.business_logo = event.target.files[0];
};

const deleteLogo = () => {
  imageUrl.value = null;
  form.value.business_logo = ''
  
};

const settings = computed(() => {
  return store.getters["settings/settings"];
});

const user = computed(() => {
  return store.getters["auth/user"];
});

const is_eligible = computed(() => {
  form.value.signatory_name = ''
  return user.value.active_subscription.plan_id === 1;
});

const getSettings = () => {
  store.dispatch("settings/getSettings").then(() => {
    form.value = {
      auto_payment_reminder: settings.value.auto_payment_reminder,
      invoice_prefix: settings.value.invoice_prefix,
      estimate_prefix: settings.value.estimate_prefix,
      service_category: settings.value.service_category,
      signatory_name: settings.value.signatory_name,
      preferred_due_date: settings.value.preferred_due_date,
      payment_history_on_invoice_page:
        settings.value.payment_history_on_invoice_page,
    };
    signatureUrl.value = settings.value.signature;
    imageUrl.value = settings.value.business_logo;
  });
};

const updateSettings = () => {
  console.log(form.value.business_logo)
  isLoading.value = true;
  store
    .dispatch("settings/updateInvoiceGenaralSettings", form.value)
    .then(() => {
      isLoading.value = false;
    })
    .catch(() => {
      isLoading.value = false;
    });
};

onMounted(() => {
  getSettings();
});
</script>

<style scoped>
.upload-div {
  width: 100%;
  height: 90px;
  border-radius: 8px;
  position: relative;
  border: 1px solid #cccccc;
  border-style: dashed;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: white;
  color: #878a99;
}
.uploaded {
  width: fit-content;
  height: 90px;
  border-radius: 8px;
  position: relative;
  border: 1px solid #cccccc;
  border-style: dashed;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: white;
  color: #878a99;
}

.upload-img {
  width: fit-content;
  height: 100%;
  border-radius: 8px;
  object-fit: contain;
}
.upload-signature {
  width: fit-content;
  height: 100%;
  border-radius: 8px;
  object-fit: contain;
}

.upload-div input {
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0;
}

.close-icon {
  position: absolute;
  cursor: pointer;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  top: -10px;
  right: -10px;
}
</style>
